import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id',  
  'created_at', 
  'updated_at',
  { template: [ 'id', 'name', { file: ['id', 'representations', 'filename', 'url'] }] },
];
const fullAttributes = [
  'id', 
  'created_at', 
  'updated_at',
  { template: [
      'id',
      'name',
      'created_at', 
      'updated_at',
      { file: ['id', 'representations', 'filename', 'url'] },
      { pages: ['id', 'number', 'height'] },
      { elements: ['id', 'elementable', 'elementable_type', 'x', 'y', 'width', 'height', { page: ['id', 'number'] }] }
    ] 
  }
];

export const getFillTemplates = asyncThunkWrapper({ 
  model: 'fillTemplates', 
  action: 'getFillTemplates', 
  func: async ({ offset = 0 }) => {
    const params = { attributes, limit: 25, offset, orders: { created_at: 'desc' } };
    const response = await axios.get('/fill_flow/fill_templates', { params });

    return response.data;
  } 
});
export const getFillTemplate = asyncThunkWrapper({ 
  model: 'fillTemplates', 
  action: 'getFillTemplate', 
  func: async (id) => {
    const params = { attributes: fullAttributes };
    const response = await axios.get(`/fill_templates/${id}`, { params });

    return response.data;
  } 
});
export const createFillTemplate = asyncThunkWrapper({ 
  model: 'fillTemplates', 
  action: 'createFillTemplate', 
  func: async (fillTemplate) => {
    const response = await axios.post(`/fill_flow/fill_templates`, { fill_template: fillTemplate, attributes });

    return response.data;
  } 
});
export const updateFillTemplate = asyncThunkWrapper({ 
  model: 'fillTemplates', 
  action: 'updateFillTemplate', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/fill_templates/${id}`, { fill_template: { id, ...fields } });

    return { status: response.status, fillTemplate: { ...fields } };
  } 
});
export const deleteFillTemplate = asyncThunkWrapper({ 
  model: 'fillTemplates', 
  action: 'deleteFillTemplate', 
  func: async (id) => {
    const response = await axios.delete(`/fill_templates/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalFillTemplates = createAction('fillTemplates/clearLocalFillTemplates');
export const clearLocalActiveFillTemplate = createAction('fillTemplates/clearLocalActiveFillTemplate');